import './standby.scss';

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Header } from 'components/header/header';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import StandByNextSteps from './StandByNextStepCard/StandByNextStepCard';
import LoanSummaryTable from '../commons/components/LoanSummaryTable/LoanSummaryTable';
import iconEnvelopeSVG from '../../assets/icons/icon-sobre.svg';
import uploadIconSVG from '../../assets/icons/icon-upload-cloud-grey.svg';
import lendingMoto from '../assets/images/lendings-pr-stamo-personal.svg';
import modalCancelActions from 'actions/modalCancelActions';
import { bindActionCreators } from 'redux';
import { hidePreLoader, showPreLoader } from 'actions/preLoaderActions';
import { changeStandbyLoanStatus } from 'actions/aresActions';
import { PUBLICA_URL } from '../../constants';
import { DOCUMENTATION_PRODUCT_NAME, recordEventCustomOnly, RELIABLE } from 'utilities/uTagging';
import { PATH_DOCUMENTATION_FINISHED } from 'constants/uTagConstants/paths';
import { formatText, HtmlText } from 'core/i18n';
import DocumentRetryThanksModal from 'components/DocumentRetryThanksModal';
import { useModal } from 'hooks/useModal';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { recordAndSavePage } from 'actions/errorViewNavigation';

const StandBy = ({
    userProfile: {
        name,
        amount,
        term,
        totalAmount,
        monthlyFee,
        openingFee,
        tae,
        tin,
        totalCost,
        documentationStatusCounter,
        documentationUploaded,
        loanCounteroffer,
        loanApproved,
        chargingLoan,
        identityMethod,
        clientRisk,
        channel,
    },
    modalCancelActions,
    showPreLoader,
    hidePreLoader,
    changeStandbyLoanStatus,
    recordAndSavePage,
}) => {
    const { isOpen, toggleModal } = useModal({ isInitialOpen: documentationStatusCounter && documentationUploaded });
    useEffect(() => {
        recordAndSavePage(
            PATH_DOCUMENTATION_FINISHED,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            RELIABLE[identityMethod] || '',
            undefined,
            'ares',
            {
                tipoPagina: 'generica',
                tipoProceso: 'onboarding',
                pasoProceso: 'documentacion/finalizado',
                tipoOnboarding: 'ares',
                productoOnboardingDetalle: 'prestamo ares',
                nombreProducto: DOCUMENTATION_PRODUCT_NAME,
                onboardingR: clientRisk || '',
                onboardingIdMethod: RELIABLE[identityMethod],
                onboardingOrigin: ORIGIN_BY_CHANNEL[channel],
            }
        );
    }, []);

    useEffect(() => {
        handleLoanStatus();
    });

    const handleLoanStatus = async () => {
        if (
            loanCounteroffer === undefined ||
            loanApproved === undefined ||
            chargingLoan ||
            (!loanApproved && !loanCounteroffer)
        ) {
            return;
        }

        showPreLoader();
        const { changingStatus } = await changeStandbyLoanStatus({ loanCounteroffer, loanApproved });
        !changingStatus && hidePreLoader();
    };

    const cancelAction = () => {
        modalCancelActions.showModalCancel();
    };

    return (
        <div className="prospects-content">
            <DocumentRetryThanksModal onClose={toggleModal} modalIsOpen={isOpen} />
            <Header />
            <div className="prospects-step-content basic-layering">
                <div className="standby-loan standby-loan__welcome">
                    <h3>{formatText('standbyLoan-title1_ares', [name])}</h3>
                    <p>{formatText('standbyLoan-text1_ares')}</p>
                    <div className="standby-loan__welcome__disclaimer">
                        <img src={iconEnvelopeSVG} alt="icon-envelope" />
                        <p>{formatText('standbyLoan-text2_ares')}</p>
                    </div>
                </div>
                <div className="standby-loan standby-loan__next-steps">
                    <h3>{HtmlText(formatText('standbyLoan-subtitle1_ares'))}</h3>
                    <StandByNextSteps
                        title={HtmlText(formatText('standbyLoan-subtitle3_ares'))}
                        description={HtmlText(formatText('standbyLoan-text4_ares'))}
                        icon={uploadIconSVG}
                    />
                </div>
            </div>
            <div className="prospects-step-content basic-layering">
                <div className="standby-loan standby-loan__welcome">
                    <h3>{HtmlText(formatText('standbyLoan-subtitle4_ares'))}</h3>
                    <LoanSummaryTable
                        name={name}
                        tin={tin}
                        tae={tae}
                        openingFee={openingFee}
                        totalAmount={totalAmount}
                        monthlyFee={monthlyFee}
                        amount={amount}
                        frequency={term}
                        totalCost={totalCost}
                    />
                </div>
                <div className="standby-loan standby-loan__next-steps-wait">
                    <h3>{HtmlText(formatText('standbyLoan-subtitle5_ares'))}</h3>
                    <div className="standby-loan__next-steps-wait__instructions">
                        <ul>
                            <li>{HtmlText(formatText('standbyLoan-bullet1_ares'))}</li>
                            <li>{HtmlText(formatText('standbyLoan-bullet2_ares'))}</li>
                            <li>{HtmlText(formatText('standbyLoan-bullet3_ares'))}</li>
                        </ul>
                        <img src={lendingMoto} title="Lending"></img>
                    </div>
                </div>
            </div>

            <div className="form__footer">
                <RoadmapNavigation
                    buttonContinueAction={() => {
                        recordEventCustomOnly({
                            categoriaEvento: 'interaccion en documentacion finalizado',
                            accionEvento: 'entendido',
                        });
                        window.location.href = PUBLICA_URL;
                    }}
                    buttonContinueDisabled={false}
                    buttonPrevHidden={true}
                    buttonCancelAction={() => {
                        cancelAction();
                    }}
                    buttonContinueText={formatText('button-understood')}
                />
            </div>
        </div>
    );
};

export default connect(
    state => ({
        userProfile: state.userProfile,
        options: state.options,
        userProfileForm: state.userProfileForm,
    }),
    dispatch => ({
        dispatch,
        hidePreLoader: bindActionCreators(hidePreLoader, dispatch),
        showPreLoader: bindActionCreators(showPreLoader, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
        changeStandbyLoanStatus: payload => changeStandbyLoanStatus(payload, dispatch),
    })
)(StandBy);
